export default __webpack_public_path__ + "e01c5225ca771947dfe0f7df049c7ee4.svg";